const M = {
  MONTH_PICKER: "YYYY-MM",
  DATE_PICKER: "YYYY-MM-DD",
  DATE_TIME_PICKER: "YYYY-MM-DD HH:mm:ss",
  REVERSE_MONTH_EN: "MMM DD"
};
export {
  M as DATE_FORMAT_MAP
};
//# sourceMappingURL=time.js.map
